module.exports = __webpack_public_path__ + "static/media/france.9cf01a0d.svg";